var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.53,3.18L12.73,3.21L13.02,3.44L13.12,3.64L14.74,7.74L16.39,3.64L16.53,3.38L16.69,3.25L16.92,3.18L22.47,3.18L22.77,3.28L23.0,3.58L23.0,3.87L20.82,9.26L20.82,20.26L20.69,20.62L20.29,20.82L3.74,20.82L3.38,20.69L3.18,20.29L3.18,9.29L1.0,3.91L1.07,3.44L1.26,3.25Z M2.39,4.3L4.11,8.7L13.95,8.7L12.2,4.3Z M17.35,4.3L17.25,4.4L15.57,8.7L19.89,8.7L21.65,4.3Z M4.34,9.79L4.3,19.7L14.21,19.7L14.21,9.79Z M15.34,9.79L15.3,19.7L19.7,19.7L19.7,9.79Z M9.13,15.3L12.66,15.3L12.92,15.44L13.09,15.7L13.09,18.21L12.99,18.41L12.69,18.61L9.16,18.61L8.93,18.51L8.7,18.18L8.7,15.77L8.8,15.53Z M9.82,16.39L9.79,17.52L12.0,17.52L12.0,16.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.a6339aded58f2167c666a246ef4e66d4.svg";
export { ForwardRef as ReactComponent };